// extracted by mini-css-extract-plugin
module.exports = {"wrap":"coverageAttestationCalendar_wrap__1dxdU","icon":"coverageAttestationCalendar_icon__2m6BF","paragraph":"coverageAttestationCalendar_paragraph__Unx6R"};